import { render, staticRenderFns } from "./ReturnOverdueList.vue?vue&type=template&id=0df82c20&scoped=true"
import script from "./ReturnOverdueList.vue?vue&type=script&lang=js"
export * from "./ReturnOverdueList.vue?vue&type=script&lang=js"
import style0 from "./ReturnOverdueList.vue?vue&type=style&index=0&id=0df82c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df82c20",
  null
  
)

export default component.exports